import Nullstack from 'nullstack';
export default function IconListSearch({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-list-search",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "15",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 18.5l2.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 6h16"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M4 18h4"
  }), " ");
}